<template>
  <div class="article">
    <div class="article--theme-gray">
      <div class="article__header">
        <router-link class="article__logotype" to="/">
          <SvgSymbol use="#youth-logotype"/>
        </router-link>
      </div>
      <div class="article__view">
        <router-view />
      </div>
      <div class="article__footer">
        <OutlinesButton text="回首頁" @click.native.prevent="onHomeClick"/>
        <OutlinesButton :text="nextTitle" @click.native.prevent="onNextClick"/>
      </div>
    </div>
    <div class="article--theme-white">
      <TheComments class="article__comments" :url="projectUrl"/>
      <TheFooter/>
    </div>
  </div>
</template>

<script>
import OutlinesButton from '@/components/OutlinesButton'
import TheComments from '@/components/TheComments'
import TheFooter from '@/components/TheFooter'
import articles from '@/data/articles'

export default {
  name: 'Article',
  components: {
    OutlinesButton,
    TheComments,
    TheFooter
  },
  inject: [ 'projectUrl' ],
  data () {
    return {
      articles
    }
  },
  computed: {
    nextId () {
      let paths = this.$route.path.slice('/')
      let id = Number(paths[paths.length - 1]) + 1
      return (id > this.articles.length) ? 1 : id
    },
    nextTitle () {
      return this.nextId === 1 ? '第一篇' : '下一篇'
    }
  },
  methods: {
    onHomeClick () {
      this.$router.push({ name: 'home' })
    },
    onNextClick () {
      this.$ga('newmedia.send', {
        'hitType': 'event',
        'eventCategory': 'Link',
        'eventAction': 'Click',
        'eventLabel': `Next-to-article-${this.nextId}`
      })
      this.$router.push({ name: `article-${this.nextId}` })
    }
  }
}
</script>

<style lang="scss">
.article {
  position: relative;

  &--theme-gray {
    padding-bottom: 90px;
    background: #eeeeee url(~@/assets/arrow-bottom-bg-white.png) repeat-x 50% bottom;
  }

  &--theme-white {
    background: #ffffff;
  }

  &__comments {
    margin-top: 0;
    padding-top: 30px;
    @include rwd($RWD_TABLET) {
      padding-top: 40px;
    }
  }

  &__header {
    height: 175px;
    background-image:
      url(~@/assets/arrow-bottom-bg-gray.png),
      url(~@/assets/arrow-bottom-bg-red.png),
      url(~@/assets/line-background.png),
      url(~@/assets/background-pattern.png);
    background-repeat: repeat-x, repeat-x, repeat, repeat;
    background-position: 50% 112%, 50% 100%, center top, left top;
    overflow: hidden;
    @include rwd($RWD_TABLET_SMALL) {
      height: 225px;
      background-position: 20% 109%, 20% 100%, center top, left top;
    }
    @include rwd($RWD_TABLET) {
      background-position: 0% 109%, 0% 100%, center top, left top;
    }
    @include rwd($RWD_DESKTOP_WIDE_1440) {
      height: 275px;
      background-position: 0% 107%, 0% 100%, center top, left top;
    }
  }

  &__logotype {
    display: block;
    position: relative;
    top: 20px;
    width: 190px;
    height: 98px;
    margin: 0 auto;
    cursor: pointer;
    @include rwd($RWD_TABLET_SMALL) {
      top: 30px;
      width: 256px;
      height: 128px;
    }
    @include rwd($RWD_TABLET) {
    }
    @include rwd($RWD_DESKTOP) {
      top: 30px;
      left: 98px;
      width: 240px;
      height: 120px;
      margin: 0;
    }
    @include rwd($RWD_DESKTOP_WIDE_1440) {
      left: 115px;
      width: 310px;
      height: 155px;
    }
  }

  &__view {
    @include use-layer(&);
    position: relative;
    max-width: 1160px;
    margin: 0 auto;
  }

  &__info {
    padding: 22px 12px 0 20px;
    @include rwd($RWD_TABLET_SMALL) {
      padding: 35px 35px 0 35px;
    }
    @include rwd($RWD_TABLET) {
      padding: 35px 47px 0 47px;
    }
    @include rwd($RWD_DESKTOP) {
      float: left;
      width: 41%;
      margin-top: 50px;
      padding: 0 0 0 45px;
    }
    @include rwd($RWD_DESKTOP_WIDE_1440) {
      width: 43%;
      margin-top: 60px;
      padding: 0;
    }
  }

  &__title {
    display: block;
    color: #1a1a1a;
    font-size: 1.5em;
    font-weight: bold;
    line-height: 1.25em;
    letter-spacing: 0.08em;
    @include rwd($RWD_TABLET_SMALL) {
      font-size: 1.875em;
      line-height: 1.2em;
    }
    @include rwd($RWD_TABLET) {
      font-size: 2.25em;
      line-height: 1.333em;
    }
    @include rwd($RWD_DESKTOP) {
      font-size: 1.875em;
      line-height: 1.2em;
    }
    @include rwd($RWD_DESKTOP_WIDE_1440) {
      font-size: 2.5em;
      line-height: 1.2em;
    }
  }

  &__subtitle {
    margin-top: 6px;
    color: #a51111;
    font-size: 1.125em;
    font-weight: bold;
    line-height: 1.333em;
    letter-spacing: 0.08em;
  }

  &__reporter {
    margin: 12px 2px;
    font-size: 0.875em;
    font-weight: bold;
    line-height: 1.5em;
    letter-spacing: 0.1em;
    text-align: justify;
      text-justify: inter-word;
    @include rwd($RWD_TABLET_SMALL) {
      margin: 18px 4px 15px 4px;
    }
    @include rwd($RWD_TABLET) {
      font-size: 1em;
    }
    @include rwd($RWD_DESKTOP) {
      margin: 25px 4px 30px 4px;
      font-size: 0.875em;
    }
    @include rwd($RWD_DESKTOP_WIDE_1440) {
      margin: 25px 4px 35px 4px;
      font-size: 1em;
    }
  }

  &__figure {
    display: block;
    margin: 0;
    padding: 10px;
    @include rwd($RWD_TABLET_SMALL) {
      padding: 10px 0;
    }
    @include rwd($RWD_TABLET) {
      padding: 10px 45px;
    }
    @include rwd($RWD_DESKTOP) {}
    @include rwd($RWD_DESKTOP_WIDE_1440) {}

    &-photo {
      background: #e6e6e6 no-repeat top center / cover;
      @include use-fixed-ratio(4, 3);
    }

    &-caption {
      position: relative;
      margin: 7px 0 0 0;
      padding-left: 35px;
      font-size: 0.875em;
      font-weight: bold;
      line-height: 1.71em;
      letter-spacing: 0.1em;
      text-align: justify;
      text-justify: inter-word;
      @include rwd($RWD_TABLET_SMALL) {
        margin: 12px 36px 0 30px;
        font-size: 1em;
      }
      @include rwd($RWD_TABLET) {
        margin: 12px 6px 0 0;
      }
      @include rwd($RWD_DESKTOP_WIDE) {
        margin: 12px 6px 0 12px;
      }

      &-icon {
        display: block;
        position: absolute;
        top: 2px;
        left: 8px;
        width: 16px;
        height: 15px;
        @include rwd($RWD_TABLET_SMALL) {
          top: 6px;
        }
      }
    }
  }

  &__cover {
    position: relative;
    @include rwd($RWD_DESKTOP) {
      float: right;
      width: 59%;
      margin-top: -9%;
    }
    @include rwd($RWD_DESKTOP_WIDE_1440) {
      width: 57%;
      margin-top: -10%;
      padding: 10px 10px 10px 40px;
    }
  }

  &__figure-in-article {
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
  }

  &__paragraph-title {
    margin: 35px 20px 10px 20px;
    color: #a51111;
    font-size: 1.25em;
    font-weight: bold;
    line-height: 1.2em;
    letter-spacing: 0.05em;
    @include rwd($RWD_TABLET_SMALL) {
      margin: 50px 35px 15px 35px;
      font-size: 1.5em;
      line-height: 1.25em;
      letter-spacing: 0.1em;
    }
    @include rwd($RWD_TABLET) {
      margin: 50px 50px 15px 50px;
    }
    @include rwd($RWD_DESKTOP) {}
    @include rwd($RWD_DESKTOP_WIDE_1440) {
      margin: 50px 0 15px 0;
      font-size: 1.875em;
      line-height: 1.2em;
    }
  }

  &__paragraph-title + &__paragraph {
    margin: 10px 20px;
    @include rwd($RWD_TABLET_SMALL) {
      margin: 15px 35px;
    }
    @include rwd($RWD_TABLET) {
      margin: 15px 50px;
    }
    @include rwd($RWD_DESKTOP) {}
    @include rwd($RWD_DESKTOP_WIDE_1440) {
      margin: 15px 0 15px 0;
    }
  }

  &__paragraph {
    margin: 20px 20px;
    font-size: 1em;
    font-weight: bold;
    line-height: 1.5em;
    letter-spacing: 0.1em;
    text-align: justify;
    text-justify: inter-word;
    @include rwd($RWD_TABLET_SMALL) {
      margin: 25px 35px;
      font-size: 1.125em;
      line-height: 1.667em;
    }
    @include rwd($RWD_TABLET) {
      margin: 35px 50px;
    }
    @include rwd($RWD_DESKTOP) {}
    @include rwd($RWD_DESKTOP_WIDE_1440) {
      margin: 35px 0 35px 0;
    }

    &:first-of-type {
      @include rwd($RWD_DESKTOP) {
        clear: left;
      }
    }
  }

  &__footer {
    margin: 50px 0 0 0;
    text-align: center;
    @include rwd($RWD_TABLET_SMALL) {
      margin: 50px 0 10px 0;
    }
    @include rwd($RWD_TABLET) {
      margin: 60px 0 30px 0;
    }
    @include rwd($RWD_DESKTOP) {
      margin: 50px 0 30px 0;
    }
    @include rwd($RWD_DESKTOP_WIDE_1440) {
      margin: 70px 0 20px 0;
    }

    .outlines-button {
      min-width: 130px;
      @include rwd($RWD_TABLET) {
        min-width: 160px;
      }
      @include rwd($RWD_DESKTOP) {
        min-width: 143px;
      }
      &__text {
        @include rwd($RWD_TABLET) {
          font-size: 1.125em;
          line-height: 1.667em;
          letter-spacing: 0.1em;
        }
        @include rwd($RWD_DESKTOP) {
          font-size: 1em;
          line-height: 1.875em;
          letter-spacing: 0.1em;
        }
      }

      & + .outlines-button {
        margin-left: 20px;
      }
    }
  }

  &__chart {
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
    padding: 20px 20px;
    @include rwd($RWD_TABLET_SMALL) {
      padding: 40px 35px;
    }

    @include rwd($RWD_TABLET) {
      padding: 40px 50px;
    }

    @include rwd($RWD_DESKTOP) {
      padding: 60px 70px;
    }
  }

  &__chart-caption {
    padding-bottom: 15px;
    font: normal 100%/150% "Montserrat", "Noto Sans TC", "Noto Serif TC", sans-serif;
    font-size: 0.9375em;
    text-align: center;

    @include rwd($RWD_TABLET) {
      font-size: 1em;
    }

    @include rwd($RWD_DESKTOP) {
      padding-bottom: 20px;
    }
  }

  &__chart-figure {
    position: relative;
    color: #1A1A1A;

    .svg-symbol {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  &__chart-annotation {
    margin: 10px 5px 0 5px;
    text-align: right;

    span {
      display: block;
      color: #7e7e7e;
      font-size: 0.75em;
      font-family: "Montserrat", "Noto Sans TC", "Noto Serif TC", sans-serif;
      letter-spacing: 0.05em;
      @include rwd($RWD_TABLET_SMALL) {
        display: inline-block;
      }

      & + span {
        &:before {
          @include rwd($RWD_TABLET_SMALL) {
            content: "/";
            margin: 0 0.5em;
          }
        }
      }
    }
  }

  &__chart-extended {
    position: relative;
    text-align: left;

    &-link {
      display: inline-block;
      color: #7e7e7e;
      margin-left: 40px;
      padding: 5px 10px;
      border: 1px solid #7e7e7e;
      border-radius: 2px;
      @include rwd($RWD_TABLET_SMALL) {
        z-index: 10;
        position: absolute;
        top: -50px;
        right: 0;
        margin-left: 0;
      }

      &:active {
        transform: translateY(1px);
      }

      .svg-symbol {
        display: inline-block;
        width: 22px;
        height: 22px;
        vertical-align: middle;
      }

      span {
        margin-left: 6px;
        font-size: 0.875em;
        font-weight: bold;
        letter-spacing: 0.05em;
        vertical-align: middle;
      }
    }
  }

  .dictionary {
    margin: 0 -0.4em;
  }
}

.desktop {
  .article {
    &__chart-extended {
      &-link {
        &:hover {
          border-color: #1a1a1a;
          span {
            color: #1a1a1a;
          }
        }
      }
    }
  }
}
</style>
